(function () {
  // Drop areas in % of the scene: [left, top, width, height]. Placed for the pouring scene.
  var SCENES = {
    wide: { now: [9, 41, 42, 26], next: [61.5, 17, 20.5, 64], size: 8 },
    tall: { now: [8, 55, 82, 20], next: [40, 9, 31, 32], size: 13 }
  };
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 0C11 7 13 9 20 10C13 11 11 13 10 20C9 13 7 11 0 10C7 9 9 7 10 0Z" fill="F"/></svg>';
  var mq = window.matchMedia('(max-width: 749px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dragging = false;
  document.addEventListener('touchmove', function (e) { if (dragging) e.preventDefault(); }, { passive: false });

  function store(key, val) { try { if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null'); sessionStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; } }

  function init(root) {
    if (root.dataset.tddReady) return;
    root.dataset.tddReady = '1';
    var stage = root.querySelector('[data-stage]');
    var zones = { now: root.querySelector('[data-zone="now"]'), next: root.querySelector('[data-zone="next"]') };
    var pieces = Array.prototype.slice.call(root.querySelectorAll('[data-piece]'));
    var prefix = root.dataset.prefix || 'pour';
    var key = 'tdd-pour-' + root.id;
    var placed = {}, selected = null;
    var scene = function () { return SCENES[mq.matches ? 'tall' : 'wide']; };
    var byId = function (id) { for (var i = 0; i < pieces.length; i++) if (pieces[i].dataset.piece === id) return pieces[i]; return null; };

    function layout() {
      var s = scene();
      ['now', 'next'].forEach(function (z) { var r = s[z], el = zones[z]; el.style.setProperty('--zx', r[0] + '%'); el.style.setProperty('--zy', r[1] + '%'); el.style.setProperty('--zw', r[2] + '%'); el.style.setProperty('--zh', r[3] + '%'); });
      Object.keys(placed).forEach(function (id) { var p = placed[id], c = inZone(p.zone, p.fx, p.fy); p.x = c[0]; p.y = c[1]; draw(id); });
    }
    function inZone(z, fx, fy) { var r = scene()[z]; return [r[0] + r[2] * fx, r[1] + r[3] * fy]; }
    function toFraction(z, x, y) { var r = scene()[z]; var fx = (x - r[0]) / r[2], fy = (y - r[1]) / r[3]; return [Math.min(.85, Math.max(.15, fx)), Math.min(.8, Math.max(.25, fy))]; }

    function draw(id) {
      var p = placed[id], el = stage.querySelector('[data-placed="' + id + '"]'), src = byId(id);
      if (!src) return;
      if (!el) {
        el = document.createElement('button');
        el.type = 'button'; el.className = 'tdd-pour__placed'; el.dataset.placed = id;
        el.innerHTML = '<img alt="" src="' + src.dataset.src + '">';
        el.setAttribute('aria-label', 'Take ' + src.dataset.label + ' back out');
        el.addEventListener('click', function () { delete placed[id]; el.remove(); update(); });
        stage.appendChild(el);
      }
      el.classList.toggle('is-pin', p.zone === 'next');
      el.classList.toggle('is-float', p.zone === 'now');
      el.style.setProperty('--px', p.x + '%'); el.style.setProperty('--py', p.y + '%');
      el.style.setProperty('--pr', p.r + 'deg'); el.style.setProperty('--pw', scene().size + '%');
    }

    function place(id, z, x, y) {
      var f = toFraction(z, x, y), c = inZone(z, f[0], f[1]);
      placed[id] = { zone: z, fx: f[0], fy: f[1], x: c[0], y: c[1], r: (Math.random() * 12 - 6).toFixed(1) };
      draw(id); sparkle(c[0], c[1]);
      if (z === 'now') ripple(c[0], c[1]);
      update();
    }

    function sparkle(x, y) {
      if (still.matches) return;
      var cols = ['#E8CF9A', '#FBF7F4', '#D9B97A', '#F3EAEA'];
      for (var i = 0; i < 7; i++) {
        var s = document.createElement('span'), a = Math.PI * 2 * i / 7 + Math.random() * .5, d = 26 + Math.random() * 26, size = 8 + Math.random() * 8;
        s.className = 'tdd-pour__spark';
        s.style.cssText = 'left:' + x + '%;top:' + y + '%;width:' + size + 'px;height:' + size + 'px;animation-delay:' + (Math.random() * .12) + 's';
        s.style.setProperty('--sx', Math.cos(a) * d + 'px'); s.style.setProperty('--sy', Math.sin(a) * d - 8 + 'px');
        s.innerHTML = STAR.replace('F', cols[i % cols.length]);
        stage.appendChild(s);
        setTimeout(function (n) { return function () { n.remove(); }; }(s), 1100);
      }
    }
    function ripple(x, y) {
      if (still.matches) return;
      var r = document.createElement('span'); r.className = 'tdd-pour__ripple';
      r.style.left = x + '%'; r.style.top = (y + 3) + '%';
      stage.appendChild(r); setTimeout(function () { r.remove(); }, 1000);
    }

    function update() {
      var lists = { now: [], next: [] }, tags = [prefix];
      Object.keys(placed).forEach(function (id) {
        var p = placed[id], el = byId(id); if (!el) return;
        lists[p.zone].push(el.dataset.label);
        tags.push(prefix + '-' + p.zone + '-' + id);
      });
      ['now', 'next'].forEach(function (z) {
        var c = root.querySelector('[data-count="' + z + '"]'); if (c) c.textContent = lists[z].length;
        var l = root.querySelector('[data-list="' + z + '"]');
        if (l) { if (!l.dataset.empty) l.dataset.empty = l.textContent; l.textContent = lists[z].length ? lists[z].join(', ') : l.dataset.empty; l.classList.toggle('is-empty', !lists[z].length); }
      });
      var t = root.querySelector('[data-tags]'); if (t) t.value = tags.join(', ');
      pieces.forEach(function (b) { b.classList.toggle('is-used', !!placed[b.dataset.piece]); });
      store(key, placed);
    }

    function select(id) {
      if (placed[id]) return;
      selected = selected === id ? null : id;
      pieces.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.piece === selected ? 'true' : 'false'); });
      zones.now.classList.toggle('is-pick', !!selected); zones.next.classList.toggle('is-pick', !!selected);
    }
    function pct(e) { var r = stage.getBoundingClientRect(); return [(e.clientX - r.left) / r.width * 100, (e.clientY - r.top) / r.height * 100]; }
    function zoneAt(x, y) {
      for (var z in zones) { var r = zones[z].getBoundingClientRect(); if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return z; }
      return null;
    }
    ['now', 'next'].forEach(function (z) {
      zones[z].addEventListener('click', function (e) { if (!selected) return; var p = pct(e), id = selected; select(id); place(id, z, p[0], p[1]); });
    });

    pieces.forEach(function (b) {
      var id = b.dataset.piece;
      b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(id); } });
      b.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      b.addEventListener('pointerdown', function (e) {
        if (placed[id] || e.button > 0) return;
        // On touch screens a quick swipe scrolls the page; press and hold to pick a piece up.
        var touch = e.pointerType !== 'mouse';
        if (!touch) e.preventDefault();
        var sx = e.clientX, sy = e.clientY, lx = sx, ly = sy, armed = !touch, moved = false, ghost = null, timer = null;
        function lift(x, y) {
          moved = true; dragging = true; b.classList.add('is-lifted');
          ghost = document.createElement('div'); ghost.className = 'tdd-pour__ghost'; ghost.innerHTML = '<img alt="" src="' + b.dataset.src + '">'; document.body.appendChild(ghost);
          ghost.style.left = x + 'px'; ghost.style.top = y + 'px';
        }
        if (touch) timer = setTimeout(function () { armed = true; try { if (navigator.vibrate) navigator.vibrate(8); } catch (err) {} lift(lx, ly); }, 300);
        try { b.setPointerCapture(e.pointerId); } catch (err) {}
        function move(ev) {
          lx = ev.clientX; ly = ev.clientY;
          if (!armed) { if (Math.hypot(lx - sx, ly - sy) > 8) finish(); return; }
          if (!moved) { if (Math.hypot(lx - sx, ly - sy) < 6) return; lift(lx, ly); }
          ghost.style.left = lx + 'px'; ghost.style.top = ly + 'px';
          var z = zoneAt(lx, ly);
          zones.now.classList.toggle('is-hot', z === 'now'); zones.next.classList.toggle('is-hot', z === 'next');
        }
        function finish() {
          clearTimeout(timer); dragging = false; b.classList.remove('is-lifted');
          b.removeEventListener('pointermove', move); b.removeEventListener('pointerup', up); b.removeEventListener('pointercancel', finish);
          zones.now.classList.remove('is-hot'); zones.next.classList.remove('is-hot');
          if (ghost) { ghost.remove(); ghost = null; }
        }
        function up(ev) {
          var wasArmed = armed, wasMoved = moved, x = ev.clientX, y = ev.clientY;
          finish();
          if (!wasMoved) { if (!touch || !wasArmed) select(id); return; }
          var z = zoneAt(x, y);
          if (z) { var p = pct(ev); place(id, z, p[0], p[1]); }
        }
        b.addEventListener('pointermove', move); b.addEventListener('pointerup', up); b.addEventListener('pointercancel', finish);
      });
    });

    var more = root.querySelector('[data-more]');
    if (more) more.addEventListener('click', function () {
      var open = !root.classList.contains('is-more');
      root.classList.toggle('is-more', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.dataset.lessLabel : more.dataset.moreLabel;
    });
    var reset = root.querySelector('[data-reset]');
    if (reset) reset.addEventListener('click', function () { Object.keys(placed).forEach(function (id) { var el = stage.querySelector('[data-placed="' + id + '"]'); if (el) el.remove(); }); placed = {}; update(); });
    if (mq.addEventListener) mq.addEventListener('change', layout);

    // Bring back her picks after the email form reloads the page.
    var saved = store(key);
    if (saved && typeof saved === 'object') { Object.keys(saved).forEach(function (id) { if (byId(id) && saved[id] && saved[id].zone) placed[id] = saved[id]; }); }
    layout(); update();
    if (root.querySelector('[data-posted]')) showPlan();

    // Her season: one small step per goal, shown after she signs up
    function picksFor(z) {
      var out = [];
      pieces.forEach(function (b) { var p = placed[b.dataset.piece]; if (p && p.zone === z) out.push({ label: b.dataset.label, step: b.dataset.step || '', src: b.dataset.src || '' }); });
      return out;
    }
    function showPlan() {
      var plan = root.querySelector('[data-plan]'); if (!plan) return;
      var now = picksFor('now'), next = picksFor('next');
      var list = plan.querySelector('[data-plan-now]'); list.innerHTML = '';
      now.forEach(function (it, i) {
        var li = document.createElement('li'); li.className = 'tdd-pour__plan-item'; li.style.animationDelay = (i * 70) + 'ms';
        if (it.src) { var im = document.createElement('img'); im.src = it.src; im.alt = ''; im.loading = 'lazy'; li.appendChild(im); } else li.appendChild(document.createElement('span'));
        var d = document.createElement('div'), h = document.createElement('h4'), t = document.createElement('p');
        h.textContent = it.label; t.textContent = it.step; d.appendChild(h); if (it.step) d.appendChild(t); li.appendChild(d); list.appendChild(li);
      });
      var nw = plan.querySelector('[data-plan-next-wrap]');
      nw.hidden = !next.length;
      plan.querySelector('[data-plan-next]').textContent = next.map(function (x) { return x.label; }).join(' · ');
      plan.querySelector('[data-plan-empty]').hidden = !!(now.length || next.length);
      plan.querySelector('[data-save]').hidden = !(now.length || next.length);
      plan.hidden = false; root.classList.add('is-planned');
      setTimeout(function () { plan.scrollIntoView({ block: 'start' }); }, 60);
      var save = plan.querySelector('[data-save]');
      if (!save.dataset.bound) { save.dataset.bound = '1'; save.addEventListener('click', function () { saveImage(plan, now, next); }); }
    }

    function loadImg(src) {
      return new Promise(function (res) {
        if (!src) return res(null);
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { res(im); }; im.onerror = function () { res(null); };
        im.src = src.indexOf('//') === 0 ? location.protocol + src : src;
      });
    }
    function wrap(ctx, text, maxW) {
      var words = (text || '').split(' '), lines = [], line = '';
      words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
      if (line) lines.push(line); return lines;
    }
    function roundRect(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

    function saveImage(plan, now, next) {
      var btn = plan.querySelector('[data-save]'), label = btn.textContent; btn.disabled = true; btn.textContent = '…';
      var W = 1080, PAD = 80, inner = W - PAD * 2, title = plan.querySelector('[data-plan-title]').textContent, intro = (plan.querySelector('[data-plan-intro]') || {}).textContent || '';
      var serif = "'Playfair Display', Georgia, serif", sans = "Inter, system-ui, sans-serif";
      var ready = (document.fonts && document.fonts.load) ? Promise.all([document.fonts.load('400 40px "Playfair Display"'), document.fonts.load('400 24px Inter')]).catch(function () {}) : Promise.resolve();
      Promise.all([ready, loadImg(plan.dataset.logo)].concat(now.map(function (n) { return loadImg(n.src); }))).then(function (r) {
        var logo = r[1], imgs = r.slice(2);
        var m = document.createElement('canvas').getContext('2d');
        m.font = '400 26px ' + sans;
        var rows = now.map(function (n) { return wrap(m, n.step, inner - 190); });
        var rowH = rows.map(function (l) { return Math.max(150, 70 + l.length * 36) + 20; });
        m.font = '400 26px ' + sans;
        var nextLines = next.length ? wrap(m, next.map(function (x) { return x.label; }).join(' · '), inner - 60) : [];
        var noteLines = next.length ? wrap(m, plan.querySelector('[data-plan-next-note]').textContent, inner - 60) : [];
        var H = 340 + rowH.reduce(function (a, b) { return a + b; }, 0) + (next.length ? 120 + (nextLines.length + noteLines.length) * 36 : 0) + 200;
        H = Math.max(H, 1350);
        var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
        x.fillStyle = '#FBF7F4'; x.fillRect(0, 0, W, H);
        x.fillStyle = '#CBACA8'; x.fillRect(0, 0, W, 20); x.fillRect(0, H - 20, W, 20);
        x.textBaseline = 'top';
        x.fillStyle = '#A3868B'; x.font = '600 22px ' + sans; x.fillText('THE DEEN DIARIES', PAD, 80);
        x.fillStyle = '#2E2427'; x.font = '400 72px ' + serif; x.fillText(title, PAD, 120);
        x.fillStyle = '#4A3D41'; x.font = '400 28px ' + sans; x.fillText(intro, PAD, 214);
        var y = 290;
        now.forEach(function (n, i) {
          var h = rowH[i] - 20;
          x.fillStyle = '#FFFFFF'; roundRect(x, PAD, y, inner, h, 26); x.fill(); x.strokeStyle = '#E6D8DA'; x.lineWidth = 2; x.stroke();
          if (imgs[i]) x.drawImage(imgs[i], PAD + 24, y + (h - 120) / 2, 120, 120);
          x.fillStyle = '#2E2427'; x.font = '400 34px ' + serif; x.fillText(n.label, PAD + 170, y + 26);
          x.fillStyle = '#4A3D41'; x.font = '400 26px ' + sans;
          rows[i].forEach(function (l, j) { x.fillText(l, PAD + 170, y + 76 + j * 36); });
          y += rowH[i];
        });
        if (next.length) {
          y += 20; x.strokeStyle = '#C4A9AD'; x.setLineDash([10, 10]); x.beginPath(); x.moveTo(PAD, y); x.lineTo(W - PAD, y); x.stroke(); x.setLineDash([]);
          y += 30; x.fillStyle = '#2E2427'; x.font = '400 34px ' + serif; x.fillText(plan.querySelector('.tdd-pour__plan-next h4').textContent, PAD, y);
          y += 56; x.fillStyle = '#6E5258'; x.font = '400 26px ' + sans; nextLines.forEach(function (l) { x.fillText(l, PAD, y); y += 36; });
          x.fillStyle = '#4A3D41'; noteLines.forEach(function (l) { x.fillText(l, PAD, y); y += 36; });
        }
        var fy = H - 150;
        if (logo) { var lw = 360, lh = lw * logo.height / logo.width; x.drawImage(logo, (W - lw) / 2, fy - lh - 10, lw, lh); }
        x.textAlign = 'center'; x.fillStyle = '#6E5258'; x.font = 'italic 400 28px ' + serif; x.fillText(plan.dataset.sign || '', W / 2, fy + 20);
        x.fillStyle = '#A3868B'; x.font = '500 22px ' + sans; x.fillText(plan.dataset.site || '', W / 2, fy + 66);
        c.toBlob(function (blob) {
          btn.disabled = false; btn.textContent = label;
          if (!blob) return;
          var name = (plan.dataset.file || 'my-season') + '.png';
          var file = null; try { file = new File([blob], name, { type: 'image/png' }); } catch (e) {}
          if (file && navigator.canShare && navigator.canShare({ files: [file] }) && matchMedia('(pointer: coarse)').matches) {
            navigator.share({ files: [file], title: title }).catch(function () {});
            return;
          }
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; document.body.appendChild(a); a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
        }, 'image/png');
      });
    }
  }

  function initAll() { document.querySelectorAll('[data-tdd-pour]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
